import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GmdService } from '../../services/gmd.service';
import { WelcomePageDetails } from './../../model/welcome-page-details';
import * as _ from 'lodash';
import { ConfigConstants } from 'src/app/model/config-constants';
import { LoadingService } from 'axis-components/components/loading/loading.service';

@Component({
  selector: 'app-gmd-dashboard-sorting',
  templateUrl: './gmd-dashboard-sorting.component.html',
  styleUrls: ['./gmd-dashboard-sorting.component.scss']
})
export class GmdDashboardSortingComponent implements OnInit, AfterViewInit {
  orderbysets = ['+companyName', '+companyType', '+companyLocation', '+companyContacts'];
  orderbyCompany: number = 0;
  searchResults;
  public showInactive = false;
  public tableView;
  public selectedRegion;
  public selectedCountry;
  public selectedLocation;
  public regions;
  public countries;
  public locations;
  welcomePageDetails: WelcomePageDetails;
  public disableSearch = true;
  public notificationMessage = "";
  public showEditIcon = true;
  public showEditIconDesc = true;
  public welcomeMessageTitle = "Complete contact and address details for GLOBAL MARINE";
  public welcomeMessageDescription = "In this application you can search for Claim Representative & Setting Agent locations by region and/ or country.";
  public skin_url1: any = '/assets/skins/ui/oxide';
  public toolbar = '';
  public searchForm: FormGroup;
  public welcomeSaved = false;
  public welcomeSaveStatus;
  constructor(private router: Router, private gmdService: GmdService, private fb: FormBuilder, private cd: ChangeDetectorRef, public loadingService: LoadingService) { 
    this.gmdService.notificationMessage.subscribe((obs)=>
    {
      if (obs && obs !== "") {
        this.notificationMessage = obs;
      }
    })
  }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      region: '',
      country: '',
      location: ''
    });
    sessionStorage.setItem('selectedCompanyId', '');
    sessionStorage.setItem('isReadOnly', 'false');
    this.gmdService.locationCount.next(0);
    this.gmdService.contactCount.next(0);
    this.selectedRegion = sessionStorage.getItem('selectedRegionId') !== '' ? sessionStorage.getItem('selectedRegionId') : null;
    this.selectedCountry = sessionStorage.getItem('selectedCountryId') !== '' ? sessionStorage.getItem('selectedCountryId') : null;
    this.selectedLocation = sessionStorage.getItem('selectedLocationId') !== '' ? sessionStorage.getItem('selectedLocationId') : null;
    if (this.searchForm.untouched && sessionStorage.getItem('selectedRegionId') === null
    && sessionStorage.getItem('selectedCountryId') === null) {
      this.searchResults = [];
    } else {
      this.loadingService.start();
      this.search();
    }
    
    this.gmdService.getRegions().subscribe((obs)=> {
      this.regions = obs;
      if (this.selectedRegion && this.selectedRegion !== null && this.selectedRegion !== '-1' && this.selectedRegion !== -1) {
        sessionStorage.setItem('selectedRegionId', this.selectedRegion);
        const req = { regionId: Number(this.selectedRegion) };
        this.gmdService.getCountries(req).subscribe((res)=> {
          this.countries = res;
        });
      } else {
        this.selectedRegion = -1;
        sessionStorage.setItem('selectedRegionId', this.selectedRegion);
      }
      if (this.selectedCountry && this.selectedCountry !== null && this.selectedCountry !== "-1") {
        sessionStorage.setItem('selectedCountryId', this.selectedCountry);
        const req = { regionId: this.selectedRegion, countryId: this.selectedCountry };
        this.gmdService.getLocations(req).subscribe((locs) => {
          this.locations = locs;
        });
      } else {
        this.selectedCountry = -1;
        sessionStorage.setItem('selectedCountryId', this.selectedCountry);
      }
      if (this.selectedLocation && this.selectedLocation !== null) {
        sessionStorage.setItem('selectedLocationId', this.selectedLocation);
      } else {
        this.selectedLocation = '-1';
        sessionStorage.setItem('location', '');
        sessionStorage.setItem('selectedLocationId', this.selectedLocation);
      }
    });
    this.getWelcomeContent();
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  public validate() {
    if ((this.searchForm.get('region').value !== null && this.searchForm.get('region').value !== '') &&
    (this.searchForm.get('country').value !== null && this.searchForm.get('country').value !== '')) {
      this.disableSearch = false;
    } else {
      this.disableSearch = true;
    }
  }
  public clearLoc() {
    this.selectedLocation = "";
  }
  changeOrderBy(orderby: string, index: number): void {
    let direction = '+'; // default
      if (this.orderbysets[index].indexOf(orderby) !== -1) {
        if (this.orderbysets[index].indexOf('+') !== -1) { direction = '-'; }
      }
      this.orderbysets[index] = direction + orderby;
    if (orderby === 'companyLocation') {
      if (direction === '+') {
        this.tableView = _.sortBy(this.tableView, 'numberOfLocations');
      }
      if (direction === '-') {
        this.tableView = _.sortBy(this.tableView, 'numberOfLocations').reverse();
      }
    } 
    if (orderby === 'companyContacts') {
      if (direction === '+') {
        this.tableView = _.sortBy(this.tableView, 'numberOfContacts');
      }
      if (direction === '-') {
        this.tableView = _.sortBy(this.tableView, 'numberOfContacts').reverse();
      }
    }
  }
  trackByIndex(index: number): number {
    return index;
  }
  public edit(selectedCompId, numOfLocations, numOfContacts, isReadOnlyMode): void {
    this.gmdService.notificationMessage.next('');
    this.gmdService.errorNotificationMessage.next('');
    this.gmdService.locationCount.next(numOfLocations === null ? 0 : numOfLocations);
    this.gmdService.contactCount.next(numOfContacts === null ? 0 : numOfContacts);
    sessionStorage.setItem('selectedCompanyId', selectedCompId);
    this.router.navigateByUrl('/gmd/gmd-edit');
    sessionStorage.setItem('isReadOnly', isReadOnlyMode);
  }
  public onToggleClick(chkBox: boolean): void {
    if (chkBox === false) {
      this.tableView = this.searchResults.filter(e => e.status === 'N');
    }
    if (chkBox === true) {
      this.tableView = this.searchResults.filter(e => e.status === 'Y');
    }
  }
  public clear(): void {
    this.tableView = [];
    this.searchResults = [];
    this.selectedCountry = null;
    this.selectedRegion = null;
    this.selectedLocation = null;
    this.disableSearch = true;
    sessionStorage.setItem('selectedLocationId', '');
    sessionStorage.setItem('location', '');
    this.searchForm.reset();
    this.countries = [];
    this.locations = [];
    this.showInactive = false;
  }
  onRegionSelected(selectedRegion) {
    this.countries = [];
    this.locations = [];
    this.selectedCountry = '';
    this.selectedLocation = '';
    this.validate();
    if (selectedRegion && selectedRegion !== null) {
      this.selectedRegion = selectedRegion.regionId || selectedRegion;
      sessionStorage.setItem('selectedRegionId', this.selectedRegion);
      const req = { regionId: Number(this.selectedRegion) };
      this.gmdService.getCountries(req).subscribe((obs)=> {
        this.countries = obs;
      });
    } else {
      this.selectedRegion = -1;
      sessionStorage.setItem('selectedRegionId', this.selectedRegion);
    }
  }

  onCountrySelected(selectedCountry) {
    this.locations = [];
    this.selectedLocation = '';
    this.disableSearch = false;
    this.validate();
    if (selectedCountry && selectedCountry !== null) {
      this.selectedCountry = selectedCountry.countryId || selectedCountry;
      sessionStorage.setItem('selectedCountryId', selectedCountry.countryId);
      const req = { regionId: this.selectedRegion, countryId: selectedCountry.countryId };
      this.gmdService.getLocations(req).subscribe((obs) => {
        this.locations = obs;
      });
    } else {
      this.selectedCountry = -1;
      sessionStorage.setItem('selectedCountryId', this.selectedCountry);
    }
  }

  onLocationSelected(selectedLocation) {
    if (selectedLocation && selectedLocation !== null) {
      this.selectedLocation = selectedLocation.locationName || selectedLocation;
      sessionStorage.setItem('selectedLocationId', this.selectedLocation);
      sessionStorage.setItem('location', selectedLocation.locationId);
    } else {
      this.selectedLocation = '-1';
      sessionStorage.setItem('location', '');
      sessionStorage.setItem('selectedLocationId', this.selectedLocation);
    }
    this.validate();
  }

  public search(): void {
    sessionStorage.setItem('selectedRegionId', this.selectedRegion !== null ? this.selectedRegion : -1);
    sessionStorage.setItem('selectedCountryId', this.selectedCountry !== null ? this.selectedCountry : -1);
    sessionStorage.setItem('selectedLocationId', this.selectedLocation !== null ? this.selectedLocation : '-1');
    const req = { 
      "regionId" : this.selectedRegion ? Number(this.selectedRegion) : -1,
      "countryId": this.selectedCountry ? Number(this.selectedCountry) : -1,
      "locationName": this.selectedLocation ? this.selectedLocation : '-1'
    };
    this.loadingService.start();
    this.gmdService.searchCompanyInternal(req).subscribe((obs: any)=> {
      this.searchResults = obs;
      this.tableView = this.searchResults.filter(e => e.status === 'Y');
      this.loadingService.stop();
    });
  }

  public addNewCompany() {
    this.gmdService.notificationMessage.next('');
    this.gmdService.errorNotificationMessage.next('');
    sessionStorage.setItem('selectedCompanyId', "");
    this.gmdService.headerCompanyName.next('--');
    this.gmdService.headerCompanyType.next('--');
    this.router.navigateByUrl('/gmd/gmd-edit');
  }

  public getWelcomeContent() {
    const req = {
      app: ConfigConstants.GMD_APP
    };
    this.gmdService.getPublicPageData(req).subscribe((obs: any)=> {
      this.welcomeMessageTitle = decodeURI(obs[0].title);
      this.welcomeMessageDescription = decodeURI(obs[0].description);
    });
  }

  public saveWelcomePage() {
    const req = {
      app: ConfigConstants.GMD_APP,
      title: encodeURI(this.welcomeMessageTitle),
      description: encodeURI(this.welcomeMessageDescription)
    };
    this.gmdService.savePublicPageData(req).subscribe((obs: any)=> {
      if (obs && obs[0]) {
        const val = Object.values(obs[0]);
        if (val[0] === 'Update Successfully') {
          this.welcomeSaved = true;
          this.welcomeSaveStatus = "Welcome page details saved successfully !"
        }
      }
      this.getWelcomeContent();
    });
  }

  public patchFormValue() {
    if (this.regions && this.regions.length > 0) {
      this.regions.forEach((rg, i) => {
        if (rg.regionId.toString() === this.selectedRegion) {
          this.searchForm.get('region').setValue(rg.regionName);
          this.cd.detectChanges();
        }
      });
    }
    if (this.countries && this.countries.length > 0) {
      this.countries.forEach((cn) => {
        if (cn.countryId.toString() === this.selectedCountry) {
          this.searchForm.get('country').setValue(cn.countryName);
          this.cd.detectChanges();
        }
      });
    }
    if (this.locations && this.locations.length > 0) {
      this.locations.forEach((loc) => {
        if (loc.locationName === this.selectedLocation) {
          this.searchForm.get('location').setValue(this.selectedLocation);
          this.cd.detectChanges();
        }
      });
    }
  }
  public downloadCSV() {
    this.gmdService.downloadCSV().subscribe((obs)=> {
      const blob = new Blob([obs], { type: 'text/csv;charset=utf-8' });
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.download = `Marine Claims Worldwide Directory.csv`;
      a.href = data;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(data);
      a.remove();
    });
  }
  public downloadPDF() {
    this.gmdService.downloadPDF().subscribe((obs)=> {
      const blob = new Blob([obs], { type: 'text/pd;charset=utf-8' });
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.download = `Marine Claims Worldwide Directory.pdf`;
      a.href = data;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(data);
      a.remove();
    });
  }
}
